import React, {useContext, useEffect, useState } from "react";
import { Row, Col, Pagination, Offcanvas, Card, Form } from 'react-bootstrap'
import { CiCircleCheck } from 'react-icons/ci'
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatDateTime ,capitalizeFirstLetter } from "../../utils/Helper";
import { ToastContainer, toast } from "react-toastify";
import DeleteModal from "../../components/common/DeleteModel";
import useMenuPermissions from "../../components/CustomHook/custompermission";

const ProductDetails = () => {
    const { id } = useParams();
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const { accessToken, logout } = useContext(UserContext);
    const headers = {
      "auth-token": authToken,
      authorization: accessToken,
    };
    const navigate = useNavigate();
    const [details ,setDetails] = useState("")
    const [showDt, setShowDt] = useState(false);
    const [selectedId , setSelectedId] = useState("");
    const permissionscontext = useMenuPermissions('/admin/products');

    useEffect(()=>{
    fetchDetails()
    },[id])

    const fetchDetails = async () => {
        try {
          const response = await APIServices.get(
            `/admin/product/details/${id}`,
            headers
          );
          if (response?.status === 200) {
            const data1 = response?.data?.list || [];
            setDetails(data1);
            } else if(response?.status === 401){
            logout();
            navigate("/");
           }else {
            setDetails([]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setDetails([]);
        }
      };

    const handleStatusChange = async (it) => {
        const newStatus = it.status === "Active" ? "Inactive" : "Active";
        try {
            const payload = { id: it.id, status: newStatus };
            const res = await APIServices.post(
            `/admin/product/status_update`,
            payload,
            headers
            );
            if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");
            fetchDetails()
            } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            showToast("Error updating status", "error");
        }
        }; 
    const handleDelete = async () => {
            try {
              if (selectedId !== null) {
                const payload = { id: selectedId };
                const res = await APIServices.post(
                  `/admin/product/delete`,
                  payload,
                  headers
                );
                if (res?.data?.status === true) {
                  showToast(res?.data?.message || "Success", "success");
                  setSelectedId(null);
                  setTimeout(() => {
                    navigate("/admin/products");
                  }, 2000);
                } else {
                  showToast(res?.data?.message || "Something went wrong.", "error");
                }
              }
              setShowDt(false);
            } catch (error) {
              console.error("Error deleting FAQ:", error);
            }
          };
    const showToast = (message, type) => {
           toast(message, {
             position: "top-right",
             autoClose: 2000,
             type,
             hideProgressBar: false,
             closeOnClick: true,
           });
         };
    return (
        <>
            <div className='channel_details_inner manager_details_sec'>
                <h2 className='font_blue_18 font-600 mb-3'>Product Details</h2>

                <div className="channel_details ">
                    <div className='cd_header'>
                        <Row className='align-items-center'>
                            <Col md={8}>
                                <div class="ch_name d-flex align-items-center">
                                    {/* <p className='font_blue_18 font-500'>PMS Strategies (Portfolio Management Services)</p> */}
                                    <p className='font_blue_18 font-500 textTransform'>{details?.name}</p>

                                </div>
                            </Col>
                            <Col md={4}>
                                <ul className="d-flex align-items-center justify-content-end gap-2">
                                    <li>
                                    <button
                                      disabled={!permissionscontext.delete}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.delete
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.delete ? 0.5 : 1,
                                      }}
                                      onClick={() => {
                                        setSelectedId(details.id);
                                        setShowDt(true);
                                        }}
                                    >
                                      <img src="/images/Trash.svg" className="img-fluid trash" alt="trash" 
                                      />
                                    </button>
                                    </li>
                                    <li> 
                                    <button
                                      disabled={!permissionscontext.edit}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.edit
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.edit ? 0.5 : 1,
                                      }}
                                      onClick={() => navigate(`/admin/update-products/${details.id}`, {
                                        state: { row:details },
                                        })}
                                    > 
                                      <img src="/images/Pen.svg" className="img-fluid pen" alt="pen"
                                    />
                                    </button>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </div>

                    <div className='cd_body mt-4'>
                        <Row className='all_details'>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Registered Date</h4>
                                    {/* <p className='font_blue_16 '>06 Feb 2025 at 12:30 PM</p> */}
                                    <p className='font_blue_16 '>{formatDateTime(details.created)}</p>

                                </div>
                            </Col>
                          
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Status</h4>
                                    <p className='font_blue_16 d-flex align-items-center'>  {details?.status}{" "}
                                    <Form className="Switch_toggle ms-2 position-relative">
                                    <input type="checkbox" id={`switch-${details.id}`} 
                                    checked={details.status === "Active"}
                                    onClick={() => handleStatusChange(details)}
                                    disabled={!permissionscontext.edit}
                                    />
                                    <label for="switch" className="position-absolute"
                                    htmlFor={`switch-${details.id}`}
                                    >Toggle</label>
                                   </Form>
                                    </p>
                                </div>
                            </Col>
                        
                            <Col md={12} lg={12}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Details</h4>
                                    {/* <p className='font_blue_16 '>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> */}
                                    <p className='font_blue_16 '>{details?.description}</p>
                                
                                </div>
                            </Col>

                        </Row>


                    </div>
                </div>

            </div>
            <DeleteModal
            showdt={showDt}
            handleCloseDt={() => setShowDt(false)}
            handledelete={handleDelete}
            />
            <ToastContainer />

        </>
    )
}

export default ProductDetails